import { __module as r } from "./chunk779.js";
import { __require as n } from "./chunk648.js";
import { __require as a } from "./chunk665.js";
var p = r.exports, o;
function m() {
  return o ? r.exports : (o = 1, function(i, u) {
    (function(e, d, t) {
      i.exports = d(n(), a());
    })(p, function(e) {
      return e.pad.NoPadding = {
        pad: function() {
        },
        unpad: function() {
        }
      }, e.pad.NoPadding;
    });
  }(r), r.exports);
}
export {
  m as __require
};
